export interface IProgressBarContainer {
  border: string;
}

export interface IIProgressBarBar {
  border: string;
  backgroundColor: string;
  color: string;
}

export interface IProgressBarVariant {
  container: IProgressBarContainer;
  bar: IIProgressBarBar;
  background: IIProgressBarBar;
}

export enum PROGRESSBAR_VARIANTS {
  PRIMARY = 'primary',
  LIGHT = 'light',
  DARK = 'dark',
}

export type IProgressBarVariants = {
  [key in PROGRESSBAR_VARIANTS]: IProgressBarVariant;
};
